import React from 'react';
import PageList from '../../components/PageListAPI'
import { getTenderOur, deleteTenderOur } from '../../api/tender.api'

export const TENDER_STATUS = [
  {value: 'draft', label:'черновик'},
  {value: 'confirm', label:'подтверждение участия'},
  {value: 'offer', label:'предложения'},
  {value: 'summering', label:'подтверждение итогов'},
  {value: 'finished', label:'завершен'},
] 

const columns = [
  { id: 'statusRus', name: 'Статус' },
  { id: 'name', name: 'Название' },
  { id: 'facilityName', name: 'Объект' },
  { id: 'typeTenderRus', name: 'Тип тендера' },
  { id: 'dateConfirmStart', name: 'Дата начала подтверждения участия', type: 'date',  formatDate:'LLL' },
  { id: 'dateConfirmEnd', name: 'Дата окончания подтверждения участия', type: 'date',  formatDate:'LLL' },
  { id: 'dateOfferEnd', name: 'Дата окончания предложения', type: 'date',  formatDate:'LLL' },
  { id: 'dateSummingEnd', name: 'Дата подведения итогов', type: 'date',  formatDate:'LLL' },
]

export default function TenderOurList(props) {
  return (
    <div className='App-paper'>
      <PageList
        title='Мои тендеры'
        name='tender-our-list'
        columns={columns}
        createItem={true}
        deleteItem={true}
        loadAPI={{
          request: getTenderOur,
          transform: (res)=>{
            return {...res, 
              get: res.get.map(e => ({ 
                ...e, 
                typeTenderRus: e.typeTender==='open'?'открытый':'закрытый',
                statusRus: TENDER_STATUS.find(s=>s.value===e.status).label 
              })) }
          }
        }}
        deleteAPI={deleteTenderOur}
        {...props}
      />
    </div>
  )
};